import React, { useContext, useState } from 'react';
import Redirect from "react-router-dom/Redirect";
import useInput from '../../../hooks/useInput';
import { Link } from "react-router-dom";

import { RiArrowGoBackLine } from 'react-icons/ri';

import { Row, Col, Button } from "react-bootstrap";
import CustomCard from '../../../components/CustomCard'
import Liquidations from '../../../components/Liquidation'
import FormLiquidation from './form'

import UsersAdminContext from "../../../context/Admin/Users/UsersAdminContext";
import SalarySettlementContext from '../../../context/SalarySettlement/SalarySettlementContext';

import {toBase64} from '../../../utils/FileUtil'
import Loading from '../../../components/Loading';

import { useToasts } from 'react-toast-notifications'
import { warningToast } from "../../../utils/ToastUtil";

const VIEW = "view";
const ADD = "add";

const SalarySettlementAdmin = (props) => {

    const { addToast } = useToasts();

    const usersAdminContext = useContext(UsersAdminContext);
    const { loading, userSelected, addLiquidation, deleteLiquidation} = usersAdminContext;
  
 
    const salarySettlementContext = useContext(SalarySettlementContext);
    const { downloadLiquidation } = salarySettlementContext;

    const { value, setValue, onChange } = useInput({});
    const [ action, setAction ] = useState(VIEW);
    const [file, setFile] = useState({filename: null, obj: {}});
    
    const actionAddByView = async () => {
        if(action === VIEW){
            setAction(ADD)
        }else if(action === ADD){
            
            const {description, period} = value;
        
            //if(!description || description.trim() === ''){  addToast('Debe Completar campo "Comentario"!', warningToast()); return; }
            if(!file || !file.name){  addToast('Debe Seleccionar un Archivo!', warningToast()); return; }
            if(!period || period.trim() === ""){  addToast('Debe Completar campo "Periodo"!', warningToast()); return; }
           
            const array = file.name.split(".");
            const extension = array[array.length -1];
            const type = file.type;
            const fileBase64 = await toBase64(file);
            const fileClean = fileBase64.split(';base64,')[1];
          

            let body = { 
                periodId: period,
                description: description,
                fileName: file.name,
                userName: userSelected.username,
                file: fileClean,
                extension: extension,
                type: type,
            } 
            let response = await addLiquidation(body);
            if(response){
                setValue({});
                setAction(VIEW)
            }
        }
    }

    const actionAddBackView = () => {
        if(action === VIEW){
            this.props.history.push(`/admin/user`);
        }else if(action === ADD){
            setAction(VIEW)
        }
    }
    
    if(!userSelected || !userSelected.run) {  return (<Redirect to = {'/'} />);}
    return ( 
        
        <>
            <Row>
                <Col>
                    <h1 className="h3 mb-2 text-gray-800">Administración de Liquidación</h1>
                    <hr />
                </Col>
            </Row>
            
            <Row >   
                <Col lg={4}>
                {action === VIEW ? 
                    <Link to={"/admin/user"}>
                        <Button   className={"col-lg-10"} variant="outline-secondary">
                            <RiArrowGoBackLine />Atrás
                        </Button>
                    </Link>
                    :  
                    <Button   className={"col-lg-10"} variant="outline-secondary" onClick={actionAddBackView}>
                        <RiArrowGoBackLine />Atrás
                    </Button>}
                </Col>        
                <Col lg={8} >       
                    <Button variant="outline-info" className={"col-lg-12"} onClick={actionAddByView} disabled={loading}>Subir Nueva Liquidación</Button>              
                </Col>
            </Row>

            <hr/>

            <CustomCard 
                titleHeader={`Liquidaciones de: ${userSelected.firstName} ${userSelected.lastName}`}
            >
                {action === VIEW ? 
                    <Liquidations
                        loading={loading}
                        user={userSelected}
                        eventDownloadLiquidation={downloadLiquidation}
                        eventDeleteLiquidation={deleteLiquidation}
                        isAdmin={true}
                    />
                    : null}

                {action === ADD ? 
                    <>
                        {loading ? 
                            <Loading />:
                            <FormLiquidation 
                                value={value}
                                setValue={setValue}
                                onChange={onChange}
                                file={file} 
                                setFile={setFile}
                            /> 
                        }
                    </>
                : null}
            </CustomCard>
        </>
     );
}
 
export default SalarySettlementAdmin;